module.exports = __webpack_public_path__ + "img/programme6.a33fe04c.png";